function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttachment = function SvgAttachment(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m607.8 854.8 309.2-309c112.8-113.3 112.5-296.5-.8-409.4-3.2-3.2-6.5-6.4-9.9-9.4-117.3-103.4-295.2-96.3-404 16.1L64.8 580.4C-14 657.9-21.9 782.3 46.7 869.1c37.8 46.2 93.5 74.1 153.1 76.8 59.4 3.1 117.3-18.8 159.7-60.4l444.8-445.6c49.5-47.8 55.9-124.8 15.1-180.1-45.4-58.9-129.9-69.8-188.7-24.4-4.5 3.4-8.7 7.2-12.7 11.1L195 671.7l50.6 50.6 422-423c21.2-21.9 54.9-25.8 80.6-9.5 29 19.3 36.9 58.4 17.6 87.4-2.3 3.5-5 6.7-7.9 9.7L309.5 833.6c-41.9 43.5-107.1 54.7-161.2 27.8-70-34.2-99-118.6-64.9-188.6 6.8-13.9 15.7-26.5 26.6-37.4l443.2-443.2c81-83.8 213-90.6 302.2-15.5 45.6 39.6 72.5 96.4 74.3 156.7 2 60.2-21 118.5-63.5 161.2L557.5 804.4z",
    style: {
      fill: "#020203"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttachment);
export default ForwardRef;